import { render } from "./Home.vue?vue&type=template&id=1ad4842c&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=1ad4842c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\joaog\\Documents\\GitHub\\deadsouls-staking\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad4842c"]])

export default __exports__